import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  // imported gsap and all plugins needed, then just register them
  gsap.registerPlugin(ScrollToPlugin, ScrollTrigger)
  // later you can use them by deconstructing useNuxtApp composable
  // but everything you put in provide will be prefixed with $ symbol to
  // prevent some collisions
  return { provide: { gsap, ScrollToPlugin, ScrollTrigger } }
})
